import React from 'react'
import Main from '../../Layout/Main'
import Tittle from '../../Components/store/Tittle'
import Cart from '../../Components/store/Cart'
import Subscribe from '../../Components/store/Subscribe'

const Store = () => {
  return (
    <Main>
        <Tittle/>
        <Cart/>
        <Subscribe/>
    </Main>
  )
}

export default Store